import React, { ReactNode } from 'react';
import { Icon, Typography } from '../common';
import Icons from '@/const/icons';
import { XMarkIcon } from '@heroicons/react/24/solid';

interface Props {
	handleClose: () => void;
	handleBack?: () => void;
	icon?: string;
	iconTitleCustom?: ReactNode;
	title: string;
	showBack?: boolean;
}

export const ModalHeaderArrowBack: React.FC<Props> = ({
	title,
	handleBack,
	handleClose,
	showBack = true,
	icon,
	iconTitleCustom,
}) => {
	return (
		<div className="flex items-center justify-between gap-2">
			{showBack && (
				<button
					type="button"
					onClick={handleBack}
					aria-label="Back"
					className="rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
				>
					<Icon src={icon ?? Icons.arrowLeft} width={24} height={24} />
				</button>
			)}
			<div className="flex items-center justify-center gap-2 flex-1">
				{iconTitleCustom ?? (
					<Icon src={Icons.documentsEmptyState} width={61} height={48} />
				)}
				<Typography type="semibold-20" className="text-black">
					{`${title}`}
				</Typography>
			</div>
			<button
				type="button"
				onClick={handleClose}
				aria-label="Close"
				className="rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
			>
				<XMarkIcon className="text-black size-6" />
			</button>
		</div>
	);
};
